import cn from 'classnames';
import jsBarcode from 'jsbarcode';
import { useState, useEffect } from 'react';
import { BiBarcodeReader } from 'react-icons/bi';

import MainLogo from '../MainLogo/MainLogo';

import styles from './ClubCardV2.module.scss';

export default function ClubCardV2({ name, points, cardNumber }) {
  const [flipCard, setFlipCard] = useState(false);

  function onClickCard() {
    setFlipCard(!flipCard);
  }

  const barCodeClick = 'Κάνε κλικ στο εικονίδιο για να δεις το barcode';

  useEffect(() => {
    jsBarcode('.barcode').init();
  }, []);

  return (
    <div
      key={cardNumber}
      className={cn({ [styles.flipped]: flipCard, [styles.userCard]: !flipCard })}
      role="button"
      tabIndex="0"
    >
      <div className={cn({ [styles.frontCard]: !flipCard, [styles.frontCard]: !flipCard })}>
        {!flipCard && (
          <div className={styles.opacityLayer}>
            <div className={styles.userCartPartContainer}>
              <div className={styles.userCartInfoContainer}>
                <p className={styles.name}>{name}</p>
                <p className={styles.points}>{`${points} Πόντοι`}</p>
              </div>
              <BiBarcodeReader className={styles.barCodeIcon} title={barCodeClick} onClick={onClickCard} />
            </div>
            <div className={styles.userCartPartContainer}>
              <div className={styles.logoContainer}>
                <MainLogo />
              </div>
              <div className={styles.userCardLowerText}>{`${process.env.loyaltyName} CARD`}</div>
            </div>
          </div>
        )}
      </div>

      <button className={styles.backCard} onClick={onClickCard}>
        <div className={styles.backCardContainer}>
          <svg
            className={cn('barcode', styles.barcode)}
            // eslint-disable-next-line react/no-unknown-property
            jsbarcode-format="ean13"
            // eslint-disable-next-line react/no-unknown-property
            jsbarcode-value={cardNumber}
          />
        </div>
      </button>
    </div>
  );
}
